import { Befehl } from '../models'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 29 has empty fields.
 *
 * Special logic for Befehl 29:
 * - Returns true if no befehl or no auftraege
 * - Otherwise uses generic logic
 */
export function hasBefehl29EmptyFields(befehl: Befehl): boolean {
  if (!befehl) return true

  if (!befehl.auftraege || befehl.auftraege.length === 0) return true

  return hasBefehlGenericEmptyFields(befehl)
}
